export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/worker.357c02d3.worker.js");
}
